import { apiClient } from './request';
import { create, fromJson, toJson, type JsonValue } from '@bufbuild/protobuf';
import type { BackgroundTask } from '@/proto/agentplatform/v1/harness_pb';
import { BackgroundTaskSchema } from '@/proto/agentplatform/v1/harness_pb';
import type { ListRequest } from '@/proto/agentplatform/httpv2/common_pb';
import { ListRequestSchema } from '@/proto/agentplatform/httpv2/common_pb';
import {
  ListBackgroundTasksResponseSchema,
  GetBackgroundTaskRequestSchema,
  GetBackgroundTaskResponseSchema,
} from '@/proto/agentplatform/httpv2/harness_pb';

export const backgroundTaskApi = {
  // application_id / status 过滤通过共享 ListRequest.filter 透传。
  list: async (params: ListRequest): Promise<{ data: BackgroundTask[]; total: number }> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/ListBackgroundTasks',
      toJson(ListRequestSchema, params)
    );
    const response = fromJson(ListBackgroundTasksResponseSchema, responseObject.data);
    return { data: response.data?.items ?? [], total: response.data?.total ?? 0 };
  },

  get: async (id: string): Promise<BackgroundTask> => {
    const responseObject = await apiClient.post<JsonValue>(
      '/v2/GetBackgroundTask',
      toJson(GetBackgroundTaskRequestSchema, create(GetBackgroundTaskRequestSchema, { id }))
    );
    const response = fromJson(GetBackgroundTaskResponseSchema, responseObject.data);
    if (!response.data) {
      throw new Error('empty response data');
    }
    return response.data;
  },

  /** Cancel a non-terminal background task (PENDING / RUNNING / WAITING_HITL). */
  cancel: async (id: string): Promise<BackgroundTask> => {
    const responseObject = await apiClient.post<JsonValue>(
      `/background-tasks/${encodeURIComponent(id)}/cancel`,
      {}
    );
    return fromJson(BackgroundTaskSchema, responseObject.data);
  },
};
